function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "40",
  height: "40",
  rx: "20",
  fill: "#4462FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.389 27.758c0-.797-1.455-3.026-1.455-3.026s-1.478 2.229-1.478 3.026c0 .796.657 1.442 1.467 1.442.809 0 1.466-.646 1.466-1.442zm-10.522-12.49h-2.933v-2.89h.8V10.8H10.4v1.578h.8v4.468c0 1.161.956 2.102 2.134 2.102h4.533v.79h1.6V14.48h-1.6v.788zM28.8 21.84v-4.468c0-1.162-.955-2.103-2.132-2.103h-4.534v-.788h-1.6v5.257h1.6v-.79h2.933v2.892h-.799v1.577H29.6V21.84h-.8z",
  fill: "#fff"
}));